import { addDays, fmtGrid } from '../dateUtils';

interface HeaderDaysProps {
  chartStart: Date;   // always a Monday now
  dayCount: number;   // always a multiple of 7
  dayWidth: number;  
}

export default function HeaderWeeks({ chartStart, dayCount, dayWidth }: HeaderDaysProps) {
  const weekCount = Math.ceil(dayCount / 7);
  const WEEK_W = dayWidth * 7;
  return (
    <div style={{ overflow: 'hidden', height: '100%', borderBottom: '1px solid #e0e0e0', boxSizing: 'border-box' }}>
      <div id="gantt-head-track" style={{ display: 'flex', height: '100%', willChange: 'transform' }}>
        {Array.from({ length: weekCount }).map((_, i) => {
          const monday = addDays(chartStart, i * 7);
          return (
            <div
              key={i}
              style={{
                width: WEEK_W,
                minWidth: WEEK_W,
                borderRight: '1px solid #e0e0e0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#5f6368',
                fontWeight: 500,
                boxSizing: 'border-box',
                whiteSpace: 'nowrap',
              }}
            >
              {fmtGrid(monday)}
            </div>
          );
        })}
      </div>
    </div>
  );
}